//@flow

import good from "./flagGood.svg"
import moderate from "./flagModerate.svg"
import sensitive from "./flagSensitive.svg"
import unhealthy from "./flagUnhealthy.svg"
import very_unhealthy from "./flagVeryUnhealthy.svg"
import hazardous from "./flagHazardous.svg"

import type { CAMMStatus } from "../queries"

const flags: { [CAMMStatus]: string } = {
  good,
  moderate,
  sensitive,
  unhealthy,
  very_unhealthy,
  hazardous
}

const flagForStatus = (status: CAMMStatus): string => flags[status]

export { flagForStatus }



// WEBPACK FOOTER //
// ./src/Kiosk/Flags/index.js